import SearchableGridList from './SearchableGridList';

export default SearchableGridList;
